
const ErrorMessage = ({ title, message, className = '' }) => {
  return (
    <div className={`mb-6 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 ${className}`}>
      <div className="flex items-center">
        <svg
          className="w-5 h-5 text-red-600 dark:text-red-400 mr-2 flex-shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <div className="flex-1">
          <p className="text-red-800 dark:text-red-200 font-medium">{title}</p>
          {message && (
            <p className="text-red-700 dark:text-red-300 text-sm mt-1">{message}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;